export const FavoriteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_24579_29181)">
      <path
        d="M19.2059 8.63215C19.4518 8.38631 19.5747 8.07901 19.4518 7.77171C19.3903 7.46441 19.083 7.28003 18.7757 7.21857L13.6131 6.48106C13.4287 6.48106 13.1214 6.23522 13.06 6.05084L10.7245 1.37989C10.4172 0.765296 9.55675 0.765296 9.24946 1.37989L6.91398 6.05084C6.85252 6.23522 6.54522 6.4196 6.36085 6.48106L1.19822 7.21857C0.829466 7.28003 0.583627 7.46441 0.522167 7.77171C0.460707 8.07901 0.522167 8.38631 0.768006 8.63215L4.51705 12.3197C4.63997 12.4427 4.76289 12.8114 4.70143 12.9958L3.841 18.097C3.77954 18.4657 3.90245 18.7116 4.02537 18.8345C4.27121 19.0803 4.63997 19.1418 5.00873 18.9574L9.61821 16.499C9.80259 16.4375 10.1714 16.4375 10.2943 16.499L14.9038 18.9574C15.0881 19.0189 15.2111 19.0803 15.334 19.0803C15.5798 19.0803 15.7642 19.0189 15.8871 18.8345C16.01 18.7116 16.1329 18.4657 16.0715 18.097L15.2111 12.9343C15.1496 12.75 15.2725 12.4427 15.3954 12.2583L19.2059 8.63215Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_24579_29181">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
